

export const index = 3;
let component_cache;
export const component = async () => component_cache ??= (await import('../entries/pages/categories/_page.svelte.js')).default;
export const imports = ["_app/immutable/nodes/3.DRFe5hMm.js","_app/immutable/chunks/2pkelJKV.js","_app/immutable/chunks/DdPEVikY.js","_app/immutable/chunks/BfCX6gG4.js","_app/immutable/chunks/DTYEGOkv.js","_app/immutable/chunks/CB2PMI89.js","_app/immutable/chunks/C5Wqr9Fc.js","_app/immutable/chunks/DkMK8g04.js","_app/immutable/chunks/B-Y5Gt5S.js"];
export const stylesheets = [];
export const fonts = [];
